module.exports = __webpack_public_path__ + "images/emoji/peach.f2aa29a26d1f9af541d3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/peach.png
// module id = PhPe
// module chunks = 13